import { Box, Button, IconButton, MenuItem, Paper, Select, Tooltip, Typography } from "@mui/material";
import { AddCircleOutline, ArrowBack, ArrowForward, CrisisAlert, FilterAlt, North, South } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { UserType, Violation } from "../../Types/UnitFeatureTypes";
import { reportedViolations } from "../../Data/DummyData";
import { useEffect, useState } from "react";
import BuildViolationsTable from "../BuildTables/BuildViolationsTable";
import { useDispatch, useSelector } from "react-redux";
import { fetchViolation, fetchViolationCount } from "../../Redux/selectors";
import { Actions, RootState } from "../../Redux/Reducer/rootReducer";
import { FIXED_PAGE_ROWS } from "../../Utils/Constants";
import { useAuth } from "../../context/authContext";
import LoadingOverlay from "../CommonComponents/LoadingOverlay";
import SortComponent from "../CommonComponents/SortComponent";
import PageNavigation from "../CommonComponents/PageNavigation";
import ViewTableHeader from "../CommonComponents/ViewTableHeader";

const ViewViolationsTable: React.FC = () => {

    const navigate = useNavigate();
    const allViolations = useSelector(fetchViolation) as Violation[];
    const allViolationsCount = useSelector(fetchViolationCount) as string;
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [sortDirection, setSortDirection] = useState<boolean>(false);
    const [sortColumn, setSortColumn] = useState<string>('created_on');
    const [item, setItem] = useState<Violation[]>([]);
    const dispatch = useDispatch();
    const { user} = useAuth();
    const isLoading = useSelector((state: RootState) => state.fetchViolation.request.loading);
    const IS_MANAGER = user?.type === UserType.MANAGER;

    useEffect(() => {
        dispatch(Actions.fetchViolation.violationActions.request({offset: (currentPage)*FIXED_PAGE_ROWS, sortColumn, sortDirection: sortDirection ? 'asc' : 'desc'}));
    },[currentPage, allViolationsCount, sortDirection, sortColumn]);

    useEffect(() => {
        setItem(allViolations);
    }, [allViolations]);

    useEffect(() => {
        const totalRequest = Number(allViolationsCount);
        const pages = Math.ceil(totalRequest/FIXED_PAGE_ROWS);
        setTotalPages(pages);
    }, [allViolationsCount]);

    const handleAddViolation = (event: React.MouseEvent<HTMLButtonElement>) => {
        navigate('/createViolation');
    }

    return (
        <>
        <LoadingOverlay isLoading={isLoading} />
        <Paper elevation={5} sx={{mb: 2, padding: 3, borderRadius: 3}}>
            <ViewTableHeader
                title="Task List"
                icon={CrisisAlert}
                handleAdd={handleAddViolation}
                addText="Add Violation"
                sortColumn={sortColumn}
                setSortColumn={setSortColumn}
                sortDirection={sortDirection}
                setSortDirection={setSortDirection}
                sortValues={[
                    { value: 'created_on', label: 'Create Date'},
                    { value: 'title', label: 'Name'},
                    { value: 'due_date', label: 'Due Date'},
                    { value: 'priority', label: 'Priority'},
                ]}
                allowAdd={IS_MANAGER}
            />
            <BuildViolationsTable item={item} />
            <PageNavigation
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalPages={totalPages}
            />
        </Paper>
        </>
    )
}

export default ViewViolationsTable;